import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const user = localStorage.getItem("GuideproAI_user");

  // If the user is authenticated, redirect to a protected page
  if (user) {
    return <Navigate to="/" />;
  }

  // If not authenticated, allow access to the public page (e.g., login)
  return children;
};

export default PublicRoute;
